import { useOneTimePass } from "@/features/accounts/payment/scraping/hooks/use-one-time-pass";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { ImageBox } from "@/shared/components/image-box/image-box";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import React, { useEffect, useContext } from "react";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useOneTimePassContext } from "@/features/accounts/payment/scraping/contexts/one-time-pass-context";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { MoneyLinkWarning } from "@/shared/utils/custom-exception";
import { ErrorDialogContext } from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";


interface CodeProps {
  processType: "reg" | "upd" | "conv" | "updAcc" | "updTrades" | ""; // reg: 口座登録, upd: ログイン情報更新, conv: 登録方式コンバート, updAcc: 口座更新(スクレイピング), updTrades: 明細更新
  onTapCloseModal: () => void;
  onTapCompleteModal: (otpInfo?: string) => Promise<void>;
}

// ワンタイムパスワードモーダル
export const OneTimePassModal = ({
  processType,
  onTapCloseModal,
  onTapCompleteModal,
}: CodeProps) => {
  const {
    setOpenHomeModal,
  } = useModalContext();
  const {
    selectedInstitutionService,
  } = useInstitutionsContext();
  const {
    selectedAccount,
  } = useAccountGroupsContext();
  const {
    count,
    setCount,
    oneTimePassList,
  } = useOneTimePassContext();
  const {
    inputPass,
    setInputPass,
    isActiveImageBox,
    setIsActiveImageBox,
    isActiveTextBox,
    setIsActiveTextBox,
    validConfirmButton,
    onChangeOtpTextBox,
    changeConfirmButtonState,
    onClickOtpConfirm,
    resetOtpModal,
  } = useOneTimePass();
  const [isCompleteOtp, setIsCompleteOtp] = React.useState(false);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);
  // 確認ボタンに付与するID
  const otpConfirmButton = "otp_confirm_button";

  const handleConfirm = async () => {
    const res = onClickOtpConfirm(oneTimePassList[count]);
    if (res?.status === "next") {
      setIsActiveTextBox(false);
      if (oneTimePassList.length > count + 1) {
        resetOtpModal();
        setCount(count + 1);
      }
      else if (oneTimePassList.length === count + 1) {
        if (processType === "updTrades") {
          loadingCtx.setIsLoading(true);
          loadingCtx.setActiveButtonId(otpConfirmButton);
          await onTapCompleteModal(res.newOtpInfo);
          // updateTrades完了後もポーリング待機中はローディングを維持
          loadingCtx.setIsLoading(true);
          loadingCtx.setActiveButtonId(otpConfirmButton);
        }
        else {
          setIsCompleteOtp(true);
        }
      }
      else {
        setError(new MoneyLinkWarning({
          title: "エラー",
          message: "ワンタイムパスワードの処理中にエラーが発生しました。",
        }));
      }
    }
    else {
      setError(new MoneyLinkWarning({
        title: "エラー",
        message: "ワンタイムパスワードの処理中にエラーが発生しました。\n最初からやり直してください。",
      }));
      setOpenHomeModal("PaymentLoginInfo");
    }
  };
  useEffect(() => {
    setInputPass("");
    setIsActiveImageBox(oneTimePassList[count].type === "2");
    setIsActiveTextBox(oneTimePassList[count].type !== "3");
  }, [oneTimePassList, count]);

  useEffect(() => {
    changeConfirmButtonState(oneTimePassList[count].type);
  }, [count, inputPass]);

  useEffect(() => {
    if (isCompleteOtp) {
      onTapCompleteModal(undefined);
      setOpenHomeModal(undefined);
    }
  }, [isCompleteOtp]);

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const title = oneTimePassList[count].title ? `【${oneTimePassList[count].title}】` : "";
  const mainContent = oneTimePassList[count].message ? oneTimePassList[count].message : oneTimePassList[count].key;

  const institutionName = localStorage.getItem("institutionName") || "";


  return (
    <BasePageModal
      // title="認証情報"
      title={`${title}${processType === "updAcc" ? institutionName : processType === "updTrades" ? selectedAccount?.companyName : selectedInstitutionService?.companyName}によるログイン`}
      className="md-list-authentication"
      disableOverlayClose={true}
      handleClose={() => {
        onTapCloseModal();
      }}
      bottomChildren={
        <>
          <BaseRoundButton
            buttonText="キャンセル"
            className="btn-cancel"
            loadingNegative={true}
            onClick={() => {
              onTapCloseModal();
            }}
          />
          <BaseRoundButton
            buttonText="確認する"
            isActive={validConfirmButton}
            onClick={handleConfirm}
            id={otpConfirmButton}
            loadingNegative={true}
          />
        </>
      }
    >
      <h2>{mainContent}</h2>

      <ul>
      { isActiveImageBox &&
        <li>
          <ImageBox
            src={oneTimePassList[count].src || ""}
            className="one_time_pass__image_box"
          />
        </li>
      }
  
      { isActiveTextBox && (
        <li>
          <SimpleForm
            placeholder={mainContent}
            value={inputPass}
            validationRule=""
            onChange={onChangeOtpTextBox}
          />
        </li>
      )}
      </ul>
    </BasePageModal>
  );
};
